/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { TObject } from "constants/interfaces";
import warning from "./warning";
import isUndefined from "./isUndefined";

interface ISafeObject {
  (
    obj: any,
    handler?: {
      get: (target: { [key in string]: any }, prop: string) => any;
      set: (
        target: { [key in string]: any },
        prop: string,
        value: any
      ) => boolean;
    }
  ): any;
}

const safeObject: ISafeObject = (obj, handler) => {
  return new Proxy(obj, {
    get: (target, prop: string) => {
      if (prop in target) {
        return target[prop];
      }
      throw warning(`Property ${prop} does not exist on object ${target}`);
    },
    ...handler,
  });
};

export const safeAssign = (obj1: TObject, obj2: TObject) => {
  const store = { ...obj1 };
  Object.keys(obj2).forEach((key) => {
    const value = obj2[key];
    if (isUndefined(value)) return;
    store[key] = value;
  });
  return store;
};

export default safeObject;
